<template>
  <span v-if="done" style="text-align: center">
    <template v-if="hasTransport">
      <span v-if="noResults">
        <b>{{ resortName}}</b> - {{ date }} - {{ duration }} <translate>nights</translate>:
        <strong>&nbsp;{{ noResults }}</strong> <translate>results</translate>
      </span>
      <strong v-else><translate>No results found</translate></strong>
    </template>
    <strong v-else><translate>No seats available</translate></strong>
    <hr v-if="noResults" />
  </span>
</template>

<script>
export default {
  name: 'SearchResultsSummary',
  props: {
    done: Boolean,
    hasTransport: Boolean,
    resortName: String,
    duration: Number,
    noResults: Number,
    date: String
  }
}
</script>
